export enum ModalType {
  ApplicationsUpsellModal,
  AttachmentModal,
  AttachmentsUploader,
  CustomizedBlockedModal,
  BlockedModalFromModule,
  ContactInfoCallModal,
  DeleteAttachmentsModal,
  FiltersPopover,
  ImagesViewer,
  NotesModal,
  RenterDetailsModal,
  RenterProfileModal,
  ReportConversationModal,
  RequestRenterProfileModal,
  SavedReplyModal,
  SendApplicationConfirmationModal,
  SendMessageModal,
  TourSchedulingUpsellModal,
}
